import { useQuery } from '@apollo/client';
import { GET_ALL_IT_APPLICATIONS_METRICS } from '../graphql';
import type {
  GetAllItApplicationsMetricsData,
  GetAllItApplicationsMetricsVars,
} from '../types';

/**
 * Hook to fetch revenue supporting applications metrics
 * @param locationUuid - The UUID of the location to fetch the data for. If not provided, the data will be fetched for enterprise level.
 * @returns {{ totalApplications: number, loading: boolean, error: ApolloError }}
 */
export const useRevenueSupportingApplicationsMetrics = (
  locationUuid?: string,
) => {
  const variables: GetAllItApplicationsMetricsVars = locationUuid
    ? { data: {} }
    : { data: { enterpriseWide: true } };

  const result = useQuery<
    GetAllItApplicationsMetricsData,
    GetAllItApplicationsMetricsVars
  >(GET_ALL_IT_APPLICATIONS_METRICS, {
    variables,
    errorPolicy: 'all',
  });

  // Debug logging
  if (result.error) {
    console.error(
      'useRevenueSupportingApplicationsMetrics GraphQL error:',
      result.error,
    );
  }

  const totalApplications = result.data?.findAllItApplications?.length || 0;

  return {
    totalApplications,
    loading: result.loading,
    error: result.error,
  };
};
